var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClients(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "M8.023,2A6.03,6.03,0,0,0,2,8.023V18.977A6.031,6.031,0,0,0,8.023,25H18.977A5.961,5.961,0,0,0,22.8,23.589l.071-.015a.231.231,0,0,0-.011-.034A5.984,5.984,0,0,0,25,18.977V8.023A6.03,6.03,0,0,0,18.977,2Zm0,1.917H18.977a4.111,4.111,0,0,1,4.107,4.107V18.977a4.051,4.051,0,0,1-.936,2.576,9.662,9.662,0,0,0-8.5-5.5,4.764,4.764,0,1,0-.318,0,9.54,9.54,0,0,0-8.5,5.465,4.045,4.045,0,0,1-.913-2.546V8.023A4.11,4.11,0,0,1,8.023,3.917ZM13.5,8.439a2.86,2.86,0,1,1-2.856,2.86A2.862,2.862,0,0,1,13.5,8.439Zm-.015,9.52a7.754,7.754,0,0,1,7.124,4.78,4.075,4.075,0,0,1-1.632.344H8.023a4.059,4.059,0,0,1-1.651-.352A7.656,7.656,0,0,1,13.485,17.959Z",
    transform: "translate(-2 -2)",
    fill: "#92929d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.6ad62f6d.svg";
export { ForwardRef as ReactComponent };